const defaultConfig = {
	apiBase: 'http://localhost:3000',
	gtmId: 'GTM-12345',
	contentUrl: '//dev-content-masterlock.laughlinreview.com',
	bazaarVoiceScriptUrl: 'https://apps.bazaarvoice.com/deployments/sentrysafe/main_site/staging/en_US/bv.js',
	storeUrl: 'https://review-store.sentrysafe.com',
	rmsUrlBase: 'https://review.registermysafe.com'
};

const devConfig = {
	apiBase: 'https://sentrysafe.laughlinreview.com',
	gtmId: 'GTM-WZHMXT',
	contentUrl: '//dev-content-masterlock.laughlinreview.com',
	bazaarVoiceScriptUrl: 'https://apps.bazaarvoice.com/deployments/sentrysafe/main_site/staging/en_US/bv.js',
	storeUrl: 'https://review-store.sentrysafe.com',
	rmsUrlBase: 'https://review.registermysafe.com'
};

const awsReviewConfig = {
	apiBase: 'https://review.sentrysafe.com',
	gtmId: 'GTM-WZHMXT',
	contentUrl: '//reviewcdn.masterlock.com',
	bazaarVoiceScriptUrl: 'https://apps.bazaarvoice.com/deployments/sentrysafe/main_site/staging/en_US/bv.js',
	storeUrl: 'https://review-store.sentrysafe.com',
	rmsUrlBase: 'https://review.registermysafe.com'
};

const awsStageConfig = {
	apiBase: 'https://stage.sentrysafe.com',
	gtmId: 'GTM-WZHMXT',
	contentUrl: '//cdn.masterlock.com',
	bazaarVoiceScriptUrl: 'https://apps.bazaarvoice.com/deployments/sentrysafe/main_site/staging/en_US/bv.js',
	storeUrl: 'https://store.sentrysafe.com',
	rmsUrlBase: 'https://www.registermysafe.com'
};

const awsProdConfig = {
	apiBase: 'https://www.sentrysafe.com',
	gtmId: 'GTM-MVS2KT',
	contentUrl: '//cdn.masterlock.com',
	bazaarVoiceScriptUrl: 'https://apps.bazaarvoice.com/deployments/sentrysafe/main_site/production/en_US/bv.js',
	storeUrl: 'https://store.sentrysafe.com',
	rmsUrlBase: 'https://www.registermysafe.com'
};

const configEnv = process.env.REACT_APP_CONFIG || 'default';
//change this to use production as the default.
let config = awsProdConfig;

if (configEnv === 'default') {
	config = Object.assign(defaultConfig, defaultConfig);
} else if (configEnv === 'awsreview') {
	config = Object.assign(defaultConfig, awsReviewConfig);
} else if (configEnv === 'awsstage') {
	config = Object.assign(defaultConfig, awsStageConfig);
} else if (configEnv === 'awsproduction') {
	config = Object.assign(defaultConfig, awsProdConfig);
} 

export default config;


// WEBPACK FOOTER //
// ./src/config/index.js